import type {
  BookingFilters,
  CheckboxFilterItem,
  FilterQuery,
  FiltersBase,
  Pagination,
} from 'types/filters';
import { isApplied } from '../utils/dynamicFilters';

export const filtersQueryBuilder = (filters: BookingFilters) => {
  const query: FilterQuery = {};

  const {
    keywordSearch,
    startDate,
    endDate,
    statuses,
    createdByUsers,
    venues,
    spaces,
    services,
    paymentStatuses,
  } = filters;

  const getValue = (i: CheckboxFilterItem) => {
    return i.value;
  };

  if (keywordSearch) {
    query.search = keywordSearch;
  }

  if (startDate) {
    query.startDate = startDate;
  }

  if (endDate) {
    query.endDate = endDate;
  }

  if (statuses.filter(isApplied).length > 0) {
    query.status = statuses.filter(isApplied).map(getValue);
  }

  if (createdByUsers.filter(isApplied).length > 0) {
    query.createdByUserIds = createdByUsers.filter(isApplied).map(getValue);
  }

  if (services.filter(isApplied).length > 0) {
    query.serviceIds = services.filter(isApplied).map(getValue);
  }

  if (venues.filter(isApplied).length > 0) {
    query.venueIds = venues.filter(isApplied).map(getValue);
  }

  if (spaces.filter(isApplied).length > 0) {
    query.spaceIds = spaces.filter(isApplied).map(getValue);
  }

  if (paymentStatuses.filter(isApplied).length > 0) {
    query.paymentStatuses = paymentStatuses.filter(isApplied).map(getValue);
  }

  return query;
};

const sortByQueryBuilder = (sortBy?: string) => {
  if (sortBy) {
    const [sortField, sortDirection] = sortBy.split(':');
    return { sortField, sortDirection };
  }

  return {};
};

const paginationQueryBuilder = (
  { perPage, currentPage }: Pagination,
  { keywordSearch }: Pick<FiltersBase, 'keywordSearch'>
) => {
  if (keywordSearch) {
    return { perPage };
  }
  return { perPage, page: currentPage };
};

const bookingsQueryBuilder = (
  filters: BookingFilters,
  sortBy: string | undefined,
  pagination: Pagination
) => {
  return {
    ...filtersQueryBuilder(filters),
    ...sortByQueryBuilder(sortBy),
    ...paginationQueryBuilder(pagination, filters),
  };
};

export default bookingsQueryBuilder;
